import React from 'react';

import Link from 'next/link';

import * as styles from './index.module.scss';

const MAX_PAGES_TO_DISPLAY = 10;

const Pagination = ({ totalPages = 0, page = 1, path = '', searchTerm = '' }) => {
  const [currentPage, setCurrentPage] = React.useState(page);

  const getLink = (page_number) => {
    return page_number === 1 ? `${path}` : `${path}/page/${page_number}`;
  };

  const getSearchLink = (page_number) => {
    return `${path}/?term=${searchTerm}&page=${page_number}`;
  };

  const getPages = () => {
    let pages = [];
    for (let i = 1; i <= totalPages; i++) {
      pages.push(i);
    }
    return pages;
  };

  const prev = () => {
    let nextPage = currentPage - 1 >= 1 ? currentPage - 1 : currentPage;
    setCurrentPage(nextPage);
  };

  const next = () => {
    let nextPage = parseInt(currentPage) <= totalPages - MAX_PAGES_TO_DISPLAY ? parseInt(currentPage) + 1 : currentPage;
    setCurrentPage(nextPage);
  };

  const prettifyPageNumber = (num) => {
    if (num < 10) {
      return `0${num}`;
    }
    return num;
  };

  return (
    totalPages > 1 && (
      <div className={styles['pagination-wrapper']}>
        <div className={`container ${styles['container']}`}>
          {totalPages >= MAX_PAGES_TO_DISPLAY + 1 && (
            <div className={`${styles['prev']} ${currentPage <= 1 ? styles['disabled'] : ''}`} onClick={() => prev()}>
              &lt;
            </div>
          )}
          <div className={styles['pages-mask']}>
            <div className={styles['page-triggers-container']} style={{ left: `${totalPages >= MAX_PAGES_TO_DISPLAY + 1 ? `${(currentPage - 1) * -30}px` : '0px'}` }}>
              {getPages().map((page_number) =>
                page_number == page ? (
                  <span className={styles['active']} key={page_number}>
                    {prettifyPageNumber(page_number)}
                  </span>
                ) : (
                  <Link href={searchTerm ? getSearchLink(page_number) : getLink(page_number)} key={page_number}>
                    {prettifyPageNumber(page_number)}
                  </Link>
                )
              )}
            </div>
          </div>
          {totalPages >= MAX_PAGES_TO_DISPLAY + 1 && (
            <div className={`${styles['next']} ${currentPage > totalPages - MAX_PAGES_TO_DISPLAY ? styles['disabled'] : ''}`} onClick={() => next()}>
              &gt;
            </div>
          )}
        </div>
      </div>
    )
  );
};

export default Pagination;
